export default function (app) {
	app.directive('ajaxInProgress', function () {
		return {
			restrict: 'A',
			link: function (scope, element) {
				element.hide();
				scope.$on('ajax:started', function () {
					element.show();
				});
				scope.$on('ajax:finished', function () {
					element.hide();
				});
			}
		};
	});
};
